import type { BadgeProps } from '@mui/material';
import { Badge } from '@mui/material';

import type { KeyAvatarProps } from './KeyAvatar';
import { KeyAvatar } from './KeyAvatar';

interface Props extends BadgeProps {
  hasKsg: boolean;
  keyAvatarProps?: KeyAvatarProps;
}

export const KeyBadge = ({
  hasKsg,
  overlap = 'circular',
  anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'right',
  },
  children,
  className,
  keyAvatarProps,
  ...other
}: Props) => {
  return (
    <Badge
      anchorOrigin={anchorOrigin}
      overlap={overlap}
      invisible={!hasKsg}
      data-tour-id={hasKsg ? 'shortcut-with-ksg' : undefined}
      className={className}
      badgeContent={<KeyAvatar {...keyAvatarProps} />}
      {...other}
    >
      {children}
    </Badge>
  );
};
